<style lang="scss">
</style>

<template>
    <section>
        <Alert class="padding-15" show-icon>操作提示：带有”<span class="color-danger">*</span>“的选项为必填项，其他为选填项。</Alert>
        <Form :label-width="160"  class="clearfix bg-fff padding-15" >
            <Col span="12">
            <FormItem  label='Amazon移库计划单号:'>
                <span>{{data.tranNo}}</span>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label='项目:'>
                <span>{{data.lineId|transferText('%name%',products)}}</span>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label='调出仓库:'>
                <span>{{data.orgwarehouseId|transferText('%title%(%code%)',amazonWarehouses)}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='接收仓库:'>
                <span v-if="data.srcOrgwarehouseId!=-1&&data.srcOrgwarehouseId">{{data.srcOrgwarehouseId|transferText('%title%(%code%)',warehouses)}}</span>
                <span v-else>Others</span>
            </FormItem>
                </Col>
                 <Col span="12">
            <FormItem label='期望入库日期:'>
                <span>{{data.estimateInboundAt}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='Remove Order ID:'>
                <span>{{data.removeOrderId}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='是否更换产品标:'>
                <span>{{data.isLabel==1?'是':'否'}}</span>
            </FormItem>
                </Col>
                <Col span="24">
            </Col>
            <Col span="12">
            <FormItem label='库存类型:'>
                <span>{{data.inventoryType==1?'不可售库存':'可售库存'}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='创建日期:'>
                <span>{{data.orderDate}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='目的国家:'>
                <span>{{data.extraData.country}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='州:'>
                <span>{{data.extraData.state}}</span>
            </FormItem>
                </Col>
            <Col span="12">
                <FormItem label='城市:'>
                    <span>{{data.extraData.city}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='邮编:'>
                <span>{{data.extraData.postal}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='联系人:'>
                <span>{{data.extraData.linkman}}</span>
            </FormItem>
                </Col>
                <Col span="12">
            <FormItem label='电话:'>
                <span>{{data.extraData.mobilePhone}}</span>
            </FormItem>
                </Col>
            <Col span="12">
                <FormItem label='移动电话:'>
                <span>{{data.extraData.phone}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='联系地址:'>
                <span>{{data.extraData.address}}</span>
            </FormItem>
                </Col>
            <Col span="12">
            <FormItem label='联系地址2:'>
                <span>{{data.extraData.address2}}</span>
            </FormItem>
                </Col>
            <Col span="12">
                <FormItem label='描述:'>
                <span>{{data.extraData.remark}}</span>
            </FormItem>
                </Col>
        </Form>

    </section>
</template>

<script>
import { mapState,mapGetters } from 'vuex'

export default {
    props: ['data'],
    data() {
        return {

        }
    },

    computed: {
        ...mapState('boss',['products']),
        ...mapGetters('boss', ['warehouses', 'amazonWarehouses']),
    },

}
</script>

